import React, { FC } from "react";
import { CardHeaderProps } from "@material-ui/core/CardHeader";
import { StyledMuiCardHeader } from './styles';

export type Props = {
  children?: React.ReactNode;
};

const CardHeader: FC<CardHeaderProps> = (props) => {
  return (
    <StyledMuiCardHeader {...props} />
  );
};

export default CardHeader;
